<template>
<div class="rank-agro">
  <mini-banner
   urlPicture='/images/banners/products/rank-agro.jpg'
   urlVector='/images/banners/grafic.svg'
     urlIcon='/svg/products/rank-agro.svg'>
     Оценка и ранжирование <br>сельскохозяйственных земель
    </mini-banner>

  <bread-crambs  class="breadcrumbs-bg" />

  <div class="rank-agro__container">

    <dash-text class="dash-text_blue rank-agro__text">
      ОЦЕНКА И РАНЖИРОВАНИЕ СЕЛЬСКОХОЗЯЙСТВЕННЫХ ЗЕМЕЛЬ ПОЗВОЛЯЕТ
        ОПРЕДЕЛИТЬ ОПТИМАЛЬНЫЕ ПУТИ ИХ ИСПОЛЬЗОВАНИЯ, ПОВЫСИТЬ ЭФФЕКТИВНОСТЬ
         И ИЗБЕЖАТЬ НЕРАЦИОНАЛЬНЫХ ТРАТ.
    </dash-text>
  </div>

  <description :description="description"
  class="description__title_blue"
   descTitle="Система CLASS.AGRO обеспечивает автоматизацию следующих процессов:" />

  <border-pic-list
   :picContent="picContent"
   :description="servicesItem"
    class="icon_disc grid-left border-pic_gray description__title_blue check-list__item_full-width"
    :descTitle="servisesTitle"
    @showModal="showModalWindow()"/>

  <product-slider :mainPage="mainPage" />

  <modal-mask class="modal__screens"
    :showModal="showModal" @closeModal="showModal = false">
    <div class="modal__img">
      <img class="modal__img-pic" alt="modal-screen"
      src="/images/product/data-rank.jpg">
    </div>
  </modal-mask>

</div>
</template>

<script>
import MiniBanner from '@/components/shared/MiniBanner.vue';
import BreadCrambs from '@/components/shared/BreadCrambs.vue';
import ProductSlider from '@/components/products/SliderServises.vue';
import DashText from '@/components/shared/DashText.vue';
import Description from '@/components/shared/listing/DescListing.vue';
import BorderPicList from '@/components/shared/listing/BorderPicList.vue';
import ModalMask from '@/components/shared/ModalMask.vue';

export default {
  components: {
    MiniBanner,
    BreadCrambs,
    ProductSlider,
    DashText,
    Description,
    BorderPicList,
    ModalMask,
  },
  emits: ['closeModal', 'showModal'],
  data() {
    return {
      mainPage: false,
      showModal: false,

      description: [{
        text: '<b>ОЦЕНКА КАЧЕСТВА</b><br>Оценка может поводится по ряду параметров таких как радиационный фон, химический состав и влажность почв, рельеф местности, метеорологические характеристики местности и пр.',
      },
      {
        text: '<b>РАЗРАБОТКА МЕРОПРИЯТИЙ</b><br>Разрабатываемые мероприятия должны быть направлены на улучшение качества земель и повышение эффективности их использования',
      },
      {
        text: '<b>ОЦЕНКА ИСПОЛЬЗОВАНИЯ</b><br>Исследование исторических данных обработки почв, урожайности в предыдущие годы, севооборота',
      },
      {
        text: '<b>РАЗРАБОТКА УПРАВЛЕНЧЕСКИХ РЕШЕНИЙ</b><br>В зависимости от уровня, на котором принимаются управленческие решения они могут быть стратегическими, тактическими или оперативными',
      },
      ],
      servisesTitle: 'Такие исследования дают представление о ценности территории и представляют интерес для:',
      servicesItem: [{
        text: 'государственных органов (министерств и ведомств)',
      },
      {
        text: 'инвесторов (финансовых компаний)',
      },
      {
        text: 'страховых компаний и банков',
      },
      {
        text: 'собственников земель',
      },
      {
        text: 'сельхозпредприятий различного уровня, включая малые сельхозпредприятия и фермеров',
      },
      ],
      picContent: {
        pic: '/images/product/data-rank.jpg',
        isLink: true,
      },
    };
  },
  methods: {
    showModalWindow() {
      this.showModal = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "/src/assets/css/modal.scss";

$light-gray: #D5D6D7;
$blue: #4DB6BC;

.rank-agro {
  position: relative;
  color: $light-gray;
  overflow: hidden;

  &:deep(.dash-text__container) {
    padding: 0;
  }

  &__text {
    max-width: 800px;
    &:last-child {
      margin: 30px 0 0;
    }
  }

  &__container {
    position: relative;
    z-index: 2;
    padding: 50px 180px 0;
    display: flex;
    flex-direction: column;

    &_bottom {
      padding: 0 180px 50px;
    }

    @media (max-width: 1275px) {
      padding: 50px 50px 0;
    }

    @media (max-width: 875px) {
      flex-direction: column;
    }

    @media (max-width: 480px) {
      padding: 40px 30px 0;
    }
  }
}
</style>
